import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  SEND_COMMENT,
  EDIT_COMMENT,
  DELETE_COMMENT,
} from '@core/constants/analytics';
import { CommentEntityType } from '@core/utils/commentsEntityTypes';

type CommentEvent =
  | typeof SEND_COMMENT
  | typeof EDIT_COMMENT
  | typeof DELETE_COMMENT;

const trackMaterialComment = (
  event: CommentEvent,
  properties: {
    itemId: string;
    itemType: string;
    commentId: string;
    entityType: CommentEntityType;
    spaceId: string;
    parentId?: string;
    isRbacEnabled: boolean;
  }
) => {
  const { entityType, ...restProperties } = properties;
  if (entityType !== 'material') return;
  try {
    analyticsTrackEvent(event, restProperties);
  } catch {
    // Analytics must not interrupt successful comment actions.
  }
};

export default trackMaterialComment;
